import Router from 'vue-router';
import Layout from "./pages/layout.vue"
import Detail from "./pages/detail.vue"
const routes = [
    {
        path: '/',
        name: 'Layout',
        redirect: '/detail',
        component: Layout,
        children: [
          {
            path: 'detail',
            name: 'Detail',
            component: Detail,
            meta: {
              keepAlive: true
            }
          }
        ],
    }
]

export default new Router({
    mode: 'history',
    routes
})